import css from 'styled-jsx/css';
import { zIndex, common } from '../../../theme/theme';

const style = css.global`
  .update-admin-wrapper {
    z-index: ${zIndex.allAroundModal};
  }
  .update-admin-wrapper .ant-modal-header {
    padding: 32px;
    border-bottom: 0;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .update-admin-wrapper .ant-modal-title {
    font-size: 24px;
  }
  .update-admin-wrapper .ant-modal-body {
    padding: 15px;
    padding-top: 0;
  }
  .update-admin-wrapper .ant-modal-close {
    width: 50px;
    height: 50px;
    color: black;
  }
  .update-admin-contents {
    // width: 400px;
    padding: 16px;
  }
  .update-admin-title {
    font-size: 16px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    padding: 0 17px;
    margin-top: 16px;
    margin-bottom: 10px;
  }
  .update-admin-subtitle {
    font-size: 14px;
    font-weight: 500;
    font-family: Arial, Helvetica, sans-serif;
    color: black;
    padding-top: 15px;
    padding-bottom: 10px;
  }
  .input-container {
    width: 100%;
    padding: 16px;
  }
  .update-admin-input-row-container {
    display: flex;
    justify-content: space-between;
  }
  .update-admin-input-container {
    display: flex;
    flex-direction: column;
  }
  .admin-switch-wrapper {
    margin-bottom: 3px;
  }
  .button-container {
    padding: 8px 16px 8px 16px;
  }
  .update-admin-contents :global(.submit-button) {
    ${common.button}
    ${common.submitButton}
  }
  .update-admin-contents :global(.submit-button:hover) {
    ${common.button}
    ${common.submitButton}
  }
  .update-admin-contents :global(.cancel-button) {
    ${common.button}
    ${common.cancelButton}
  }
  .update-admin-contents :global(.cancel-button:hover) {
    ${common.button}
    ${common.cancelButton}
  }
  .error {
    color: red;
    font-size: 11px;
    margin-bottom: 0;
    margin: 4px;
  }
`;

export default style;
